import type { WatchTowerMockState } from './types';

export function emptyWatchTowerState(): WatchTowerMockState {
  return {
    schemaVersion: '1',
    seedName: 'live',
    watchCompanies: [],
    watchTopics: [],
    schedules: [],
    runs: [],
    findings: [],
    findingAffectedCompanies: [],
    knownSupplierLinks: [],
    discoveryProposals: [],
    issueChats: [],
    issueChatMessages: [],
    notificationLog: [],
    createChats: [],
    createChatMessages: [],
  };
}

export function upsertById<T extends { id: number }>(base: T[], extra: T[]): T[] {
  if (!extra.length) {
    return base;
  }
  const map = new Map<number, T>();
  base.forEach((item) => map.set(item.id, item));
  extra.forEach((item) => {
    const current = map.get(item.id);
    map.set(item.id, current ? { ...current, ...item } : item);
  });
  return Array.from(map.values());
}
